/**
 * Saves a Blob as a file through a temporary link, without leaving the screen: the CSV answered
 * inline by `POST /exports`, and the integration docs' `llms-full.txt`.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
